export const SUPPLIERS_TEXT = Object.freeze({
  common: {
    noName: 'Sin nombre',
    noOptionAvailable: 'Sin opción disponible',
  },
  page: {
    title: 'Proveedores',
    subtitle: 'Gestión de proveedores y relación comercial.',
  },
  actions: {
    common: {
      cancel: 'Cancelar',
      moreActions: 'Más acciones',
      activate: 'Activar',
      disable: 'Deshabilitar',
      delete: 'Eliminar',
      save: 'Guardar',
      update: 'Actualizar',
    },
    header: {
      newSupplier: 'Nuevo',
      importSuppliers: 'Importar',
      exportSuppliers: 'Exportar',
      syncSuppliers: 'Sincronizar',
    },
    table: {
      viewDetail: 'Ver detalle',
      editSupplier: 'Editar proveedor',
      sortBySupplier: 'Ordenar por proveedor',
      sortByPendingExpenses: 'Ordenar por gastos pendientes',
      sortByPendingTotal: 'Ordenar por gasto pendiente total',
      sortByPaidTotal: 'Ordenar por gasto pagado',
      goSupplierDetail: 'Ir al detalle del proveedor',
      openPendingBreakdown: 'Ver desglose de pendientes',
      pendingExpensesEntry: (count) => `Gastos: ${count}`,
      pendingFeesEntry: (count) => `Comisiones: ${count}`,
    },
    toolbar: {
      toggleFilters: 'Filtros',
      search: 'Buscar',
    },
    modal: {
      close: 'Cerrar modal',
      sectionMenuAriaLabel: 'Secciones del formulario',
      deleteSupplier: 'Eliminar proveedor',
    },
  },
  metrics: {
    totalSuppliers: 'Total proveedores',
    pendingExpenses: 'Gastos pendientes',
    paidExpenses: 'Gastos pagados',
    latestSupplier: 'Último proveedor creado',
    latestSupplierMetaPrefix: 'Fecha de creación:',
    latestSupplierEmpty: '-',
  },
  filters: {
    searchPlaceholder: 'Buscar proveedor o contacto',
    classAllLabel: 'Clase: todas',
    fields: {
      class: {
        label: 'Clase',
        placeholder: 'Selecciona clase',
      },
      category: {
        label: 'Categoría',
        placeholder: 'Selecciona categoría',
      },
      specialty: {
        label: 'Especialidad',
        placeholder: 'Selecciona especialidad',
      },
      area: {
        label: 'Área',
        placeholder: 'Selecciona área',
      },
    },
  },
  table: {
    empty: 'Sin resultados para los filtros seleccionados.',
    loading: 'Cargando proveedores...',
    headers: {
      index: '#',
      supplier: 'Proveedor',
      category: 'Categoría',
      mainContact: 'Contacto principal',
      email: 'Email',
      pendingExpenses: 'Gastos pendientes (año actual)',
      pendingTotal: 'Gasto pendiente total (año actual)',
      paidTotal: 'Gasto pagado (año actual)',
      status: 'Estado',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
  },
  confirm: {
    toggleStatus: {
      titleDisable: 'Deshabilitar proveedor',
      titleActivate: 'Activar proveedor',
      subtitle: 'Este cambio solo actualiza el estado del proveedor.',
      messageDisable: (supplierName) => `Proveedor: ${supplierName}. ¿Estás seguro de que deseas deshabilitarlo?`,
      messageActivate: (supplierName) => `Proveedor: ${supplierName}. ¿Estás seguro de que deseas activarlo?`,
    },
    delete: {
      title: 'Eliminar proveedor',
      subtitle: 'Confirma para continuar con esta operación.',
      message: (supplierName) => `Proveedor: ${supplierName}. ¿Estás seguro de que deseas eliminarlo? Esta acción no se puede deshacer.`,
    },
    sync: {
      title: 'Sincronizar proveedores',
      subtitle: 'Esta acción refresca saldos y métricas de proveedores.',
      message: 'La sincronización revisa todos los gastos de tu cuenta para actualizar los saldos de tus proveedores con la información más reciente de egresos.\n\nEste proceso puede tardar unos minutos según el volumen de información.\n\n¿Deseas iniciar la sincronización ahora?',
      confirm: 'Iniciar sincronización',
    },
  },
  toast: {
    importPending: 'La importación de proveedores se conectará en el siguiente paso.',
    exportPending: 'La exportación de proveedores se conectará en el siguiente paso.',
    loadSupplierError: 'No fue posible cargar el proveedor.',
    saveSupplierError: 'No fue posible guardar el proveedor.',
    saveSupplierSuccess: 'El proveedor ha sido registrado correctamente.',
    updateSupplierSuccess: 'El proveedor ha sido actualizado correctamente.',
    specialtiesSyncWarning: 'El proveedor se guardó, pero no fue posible actualizar especialidades.',
    createSpecialtyError: 'No fue posible crear la especialidad.',
    actionError: 'No fue posible completar la acción solicitada.',
    toggleStatusSuccess: 'El proveedor ha sido actualizado correctamente.',
    deleteSuccess: 'El proveedor ha sido eliminado correctamente.',
    syncSuccess: 'Saldos y métricas de proveedores sincronizados correctamente.',
    syncError: 'No fue posible sincronizar los proveedores.',
    syncCooldown: (minutes) => `Ya existe una sincronización reciente. Intenta nuevamente en ${minutes} minuto${minutes === 1 ? '' : 's'}.`,
  },
  exports: {
    modal: {
      title: 'Exportar proveedores',
      subtitle: 'Selecciona la información que deseas incluir en el archivo Excel. Puedes guardar esta configuración para utilizarla nuevamente.',
      format: {
        title: 'Formato de exportación',
        selectorLabel: 'Formato',
        selectorPlaceholder: 'Selecciona una opción',
        newOption: 'Nuevo formato',
        save: 'Guardar formato',
        saveAs: 'Guardar como',
        delete: 'Eliminar formato',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        nameLabel: 'Nombre del formato',
        namePlaceholder: 'Ej. Directorio de proveedores',
        nameRequired: 'Debes capturar el nombre del formato.',
        duplicateConfirm: 'Ya existe un formato con ese nombre. ¿Deseas reemplazarlo?',
        deleteConfirm: '¿Deseas eliminar este formato de exportación?',
        copySuffix: 'copia',
      },
      columns: {
        title: 'Columnas a exportar',
        subtitle: 'Activa las columnas que deseas incluir en el archivo. El orden de selección se respeta en el Excel.',
        selectAll: 'Todas',
        clearSelection: 'Limpiar',
        restoreDefault: 'Restaurar',
        selectedCount: (count) => `${count} columna${count === 1 ? '' : 's'} seleccionada${count === 1 ? '' : 's'}`,
        warningsByGroup: {
          contact_person: 'Para las columnas de persona de contacto se toma la información de la persona marcada como principal. Si no existe, se utiliza la primera disponible.',
          billing: 'Los datos de facturación se toman del dato de facturación predeterminado del proveedor.',
        },
        orderTitle: 'Orden de columnas',
        orderSubtitle: 'Ajusta el orden con los controles de subir y bajar.',
        orderEmpty: 'No hay columnas seleccionadas.',
      },
      groups: {
        general: 'Información general',
        classification: 'Clasificación',
        contact_person: 'Contacto y persona de contacto',
        billing: 'Datos de facturación',
        address: 'Dirección',
        financial: 'Información financiera',
        commercial: 'Información comercial',
      },
      footer: {
        cancel: 'Cancelar',
        saveAndExport: 'Guardar y exportar',
        exportOnly: 'Exportar',
        exporting: 'Exportando...',
      },
      toast: {
        loadError: 'No fue posible cargar la configuración de exportación.',
        noColumns: 'Debes seleccionar al menos una columna para exportar.',
        formatSaved: 'Formato de exportación guardado correctamente.',
        formatUpdated: 'Formato de exportación actualizado correctamente.',
        formatDeleted: 'Formato de exportación eliminado correctamente.',
        formatError: 'No fue posible guardar el formato de exportación.',
        formatDeleteError: 'No fue posible eliminar el formato de exportación.',
        exportSuccess: 'Exportación de proveedores generada correctamente.',
        exportError: 'No fue posible exportar los proveedores.',
      },
    },
    settings: {
      deleteModal: {
        title: 'Eliminar formato de exportación',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (formatName) => `Formato: ${formatName}. ¿Deseas eliminar este formato de exportación? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
      table: {
        actions: {
          delete: 'Eliminar',
        },
      },
    },
  },
  imports: {
    modal: {
      title: 'Importar proveedores',
      subtitle: 'Sube archivos independientes para Proveedores, Datos de facturación y Personas.',
      sections: {
        suppliers: {
          title: 'Proveedores',
          subtitle: 'Información general, contacto, clasificación, dirección y configuración financiera del proveedor.',
        },
        billing: {
          title: 'Datos de facturación',
          subtitle: 'Información fiscal y domicilio para la facturación del proveedor.',
        },
        people: {
          title: 'Personas',
          subtitle: 'Contactos del proveedor y preferencias de envío.',
        },
      },
      upload: {
        chooseFile: 'Seleccionar archivo',
        removeFile: 'Quitar archivo',
        empty: 'Ningún archivo seleccionado',
        formats: 'Formatos permitidos: .xls, .xlsx, .csv',
        sizeHint: 'Tamaño máximo sugerido: 10 MB',
      },
      instructions: {
        title: 'Ver instrucciones para importar',
        subtitle: 'Usa exactamente los encabezados de la plantilla y evita filas vacías intermedias.',
        bullets: [
          'Selecciona una sección por vez.',
          'Descarga la plantilla de la sección seleccionada.',
          'Completa los campos obligatorios y usa los opcionales solo cuando aplique.',
          'Valida antes de importar para revisar errores por fila y columna.',
        ],
        bySection: {
          suppliers: [
            'Campo obligatorio: proveedor.',
            'Usa clase y categoría existentes para evitar errores de relación.',
            'Campos opcionales: sitio_web, comentario, email, telefono, area, direccion, pais, estado, ciudad y codigo_postal.',
          ],
          billing: [
            'Primero identifica al proveedor con la columna proveedor. Ese nombre debe existir en tu listado de proveedores.',
            'En tipo_de_contribuyente escribe solo Nacional o Extranjero.',
            'Si es Nacional: completa rfc, forma_de_pago y metodo_de_pago.',
            'También son obligatorios: razon_social, codigo_postal, regimen_fiscal y uso_cfdi.',
          ],
          people: [
            'Los campos obligatorios son proveedor y nombres.',
            'Usa Si o No en: recibe_facturas, recibe_complementos_de_pago, contacto_de_cobranza y contacto_principal.',
            'Si marcas Si en recibe_facturas o recibe_complementos_de_pago, debes capturar un email válido.',
          ],
        },
      },
      visualExample: {
        title: 'Ver ejemplo visual de la tabla esperada',
        subtitle: 'Esta tabla es una referencia visual y no es editable.',
      },
      validation: {
        title: 'Resultado de validación',
        importTitle: 'Resultado de importación',
        validationInfo: (canImport, rowsInvalid, rowsWarnings) => {
          if (canImport) {
            const warningsLabel = rowsWarnings > 0
              ? ` Se detectaron ${rowsWarnings} advertencia${rowsWarnings === 1 ? '' : 's'} que no bloquean la importación.`
              : '';

            return `Validación completada correctamente. No se detectaron errores bloqueantes.${warningsLabel} Puedes continuar con la importación.`;
          }

          return `Validación completada con ${rowsInvalid} error${rowsInvalid === 1 ? '' : 'es'} bloqueante${rowsInvalid === 1 ? '' : 's'}. Corrige los registros marcados en la tabla para continuar.`;
        },
        importSuccessInfo: (rowsTotal, rowsCreated, rowsUpdated, rowsErrors, rowsWarnings) => `Importación completada. Se procesaron ${rowsTotal} fila${rowsTotal === 1 ? '' : 's'}: ${rowsCreated} creada${rowsCreated === 1 ? '' : 's'}, ${rowsUpdated} actualizada${rowsUpdated === 1 ? '' : 's'}, ${rowsErrors} con error y ${rowsWarnings} con advertencia.`,
        summary: {
          rowsTotal: 'Filas detectadas',
          rowsValid: 'Correctas',
          rowsInvalid: 'Errores',
          rowsWarnings: 'Advertencias',
          rowsProcessed: 'Total procesadas',
          rowsCreated: 'Registros creados',
          rowsUpdated: 'Registros actualizados',
        },
        table: {
          type: 'TIPO',
          row: 'FILA',
          column: 'COLUMNA',
          message: 'MENSAJE',
          empty: 'Sin errores para mostrar.',
        },
      },
      footer: {
        cancel: 'Cerrar',
        downloadTemplate: 'Descargar plantilla',
        validate: 'Validar',
        validating: 'Validando...',
        import: 'Importar',
        importing: 'Importando...',
      },
      toast: {
        templateError: 'No fue posible descargar la plantilla.',
        validateSuccess: 'Archivos validados correctamente.',
        validateError: 'No fue posible validar los archivos.',
        importSuccess: 'Importación ejecutada correctamente.',
        importError: 'No fue posible ejecutar la importación.',
      },
      sectionRequired: 'Debes seleccionar una sección.',
      fileRequired: 'Debes cargar un archivo para la sección seleccionada.',
      examples: {
        suppliers: {
          columns: [
            'proveedor',
            'clase',
            'categoria',
            'email',
            'telefono',
            'sitio_web',
            'comentario',
            'area',
            'direccion',
            'pais',
            'estado',
            'ciudad',
            'codigo_postal',
          ],
          row: [
            'Proveedor ACME',
            'Servicios',
            'Tecnología',
            'contacto@proveedor.com',
            '5512345678',
            'https://proveedor.com',
            'Proveedor estratégico',
            'Compras',
            'Av Reforma 100',
            'México',
            'Ciudad de México',
            'Ciudad de México',
            '06000',
          ],
        },
        billing: {
          columns: [
            'proveedor',
            'tipo_de_contribuyente',
            'rfc',
            'razon_social',
            'codigo_postal',
            'regimen_fiscal',
            'uso_cfdi',
            'forma_de_pago',
            'metodo_de_pago',
            'calle',
            'no_exterior',
            'no_interior',
            'colonia',
            'municipio',
            'estado',
            'pais',
            'cuenta_de_pago',
            'rfc_banco_beneficiario',
            'banco_ordenante',
            'rfc_banco_ordenante',
            'cuenta_ordenante',
          ],
          row: ['Proveedor ACME', 'Nacional', 'XAXX010101000', 'ACME SA DE CV', '06000', '612', 'G03', '03', 'PUE', 'Av Reforma', '100', '10', 'Centro', 'Cuauhtémoc', 'Ciudad de México', 'México', '1234567890', 'XEXX010101000', 'Bank of America', 'XEXX010101000', '001122334455667788'],
        },
        people: {
          columns: [
            'proveedor',
            'nombres',
            'apellidos',
            'puesto',
            'email',
            'telefono_de_oficina',
            'extension',
            'celular',
            'telefono_de_casa',
            'telefono_adicional',
            'direccion',
            'ciudad',
            'estado',
            'codigo_postal',
            'pais',
            'recibe_facturas',
            'recibe_complementos_de_pago',
            'contacto_de_cobranza',
            'contacto_principal',
          ],
          row: ['Proveedor ACME', 'Juan', 'Pérez', 'Operaciones', 'juan@proveedor.com', '5555555555', '123', '5512345678', '', '', 'Av Reforma 100', 'Ciudad de México', 'Ciudad de México', '06000', 'México', 'Si', 'No', 'No', 'No'],
        },
      },
    },
  },
  modal: {
    createTitle: 'Nuevo proveedor',
    editTitle: 'Editar proveedor',
    subtitle: 'Captura la información operativa y financiera del proveedor.',
    submitCreate: 'Guardar',
    submitEdit: 'Actualizar',
    sections: {
      general: {
        title: 'Información general',
        description: 'Alta rápida del proveedor.',
      },
      contact: {
        title: 'Contacto',
        description: 'Canales de comunicación.',
      },
      classification: {
        title: 'Clasificación',
        description: 'Especialidades y enfoque.',
      },
      address: {
        title: 'Dirección',
        description: 'Ubicación operativa.',
      },
      financial: {
        title: 'Configuración financiera',
        description: 'Parámetros para control contable.',
      },
    },
    form: {
      general: {
        title: 'Información general',
        subtitle: 'Completa nombre, clase y categoría para crear rápidamente el proveedor.',
        fields: {
          name: 'Nombre del proveedor *',
          logo: 'Logo',
          logoPreviewAlt: 'Logo del proveedor',
          website: 'Sitio web',
          status: 'Estado',
          comment: 'Comentario',
        },
        actions: {
          removeLogo: 'Quitar logo',
          selectLogo: 'Seleccionar archivo',
        },
        placeholders: {
          name: 'Nombre del proveedor',
          logoEmpty: 'Ningún archivo seleccionado',
          website: 'https://proveedor.com',
          status: 'Selecciona estado',
          comment: 'Comentario',
        },
      },
      contact: {
        title: 'Contacto',
        subtitle: 'Canales de contacto principales del proveedor.',
        fields: {
          email: 'Email',
          phone: 'Teléfono',
          portfolio: 'Portafolio',
        },
        placeholders: {
          email: 'correo@proveedor.com',
          phone: '(00) 0000-0000',
          portfolio: 'URL o referencia',
        },
      },
      classification: {
        title: 'Clasificación',
        subtitle: 'Asigna especialidades al proveedor para filtros y segmentación.',
        fields: {
          specialties: 'Especialidades',
          area: 'Área',
          newSpecialtyName: 'Nombre de la especialidad *',
        },
        actions: {
          newSpecialty: '+ Nueva especialidad',
          saveAndUseSpecialty: 'Guardar y usar especialidad',
        },
        placeholders: {
          specialties: 'Selecciona especialidades',
          area: 'Selecciona área',
          newSpecialtyName: 'Nombre de la especialidad',
        },
      },
      address: {
        title: 'Dirección',
        subtitle: 'Ubicación para documentos y operaciones.',
        fields: {
          address: 'Dirección',
          country: 'País',
          state: 'Estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
        },
        placeholders: {
          address: 'Dirección',
          country: 'Selecciona país',
          state: 'Selecciona estado',
          city: 'Ciudad',
          zipCode: 'Código postal',
        },
      },
      financial: {
        title: 'Configuración financiera',
        subtitle: 'Parámetros para control contable.',
        fields: {
          accountingAccount: 'Cuenta contable',
        },
        placeholders: {
          accountingAccount: 'Cuenta contable',
        },
      },
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    validation: {
      nameRequired: 'El nombre es obligatorio',
      classRequired: 'La clase es obligatoria',
      categoryRequired: 'La categoría es obligatoria',
      emailInvalid: 'Correo inválido',
    },
  },
  detail: {
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    tabs: {
      summary: 'Resumen',
      contactBilling: 'Contacto y facturación',
      operation: 'Operación',
      finance: 'Finanzas',
      analysis: 'Análisis',
      documents: 'Documentos',
      settings: 'Opciones avanzadas',
      history: 'Historial',
    },
    subTabs: {
      operation: {
        expenses: 'Gastos',
        commissions: 'Comisiones',
        refunds: 'Reposiciones',
      },
      finance: {
        payments: 'Pagos',
        cfdis: 'CFDI',
      },
      analysis: {
        historicalFlow: 'Flujo histórico',
        trends: 'Tendencias',
      },
    },
    tabsPanel: {
      subSectionsAriaLabel: 'Subsecciones del proveedor',
      fallbackTitle: 'Sección',
      fallbackSubtitle: 'Esta sección estará disponible en la siguiente iteración.',
    },
    header: {
      moreActions: 'Más acciones',
      tabsAriaLabel: 'Secciones del proveedor',
      actions: {
        editSupplier: 'Editar',
        newExpense: 'Nuevo gasto',
        newCommission: 'Nueva comisión',
      },
    },
    loading: {
      detail: 'Cargando detalle del proveedor...',
    },
    metrics: {
      totalProjected: 'Total pronosticado',
      totalPaid: 'Total pagado',
      totalProjectedCurrentMonth: (monthLabel) => `Total pronosticado (${monthLabel})`,
      totalPaidCurrentMonth: (monthLabel) => `Total pagado (${monthLabel})`,
    },
    confirm: {
      deleteSupplier: {
        message: (supplierName) => `Proveedor: ${supplierName}. Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?`,
      },
    },
    settingsTab: {
      title: 'Opciones avanzadas',
      description: 'Administra accesos y acciones críticas de este proveedor.',
      cards: {
        merge: {
          title: 'Fusionar proveedor',
          description: 'Une este proveedor con otro registro.',
          warning: 'Esta acción es irreversible.',
          action: 'Fusionar proveedor',
        },
        archive: {
          title: 'Archivar proveedor',
          description: 'Oculta el proveedor sin eliminarlo.',
          action: 'Archivar',
        },
        unarchive: {
          title: 'Desarchivar proveedor',
          description: 'Vuelve a mostrar el proveedor para trabajar con él.',
          action: 'Desarchivar',
        },
        delete: {
          title: 'Eliminar proveedor',
          description: 'Solo puede eliminarse un proveedor que no tenga gastos, comisiones, o pagos relacionados.',
          action: 'Eliminar',
        },
      },
    },
    advancedOptionsConfirm: {
      archive: {
        title: 'Archivar proveedor',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (supplierName) => `Proveedor: ${supplierName}. ¿Deseas archivarlo? Podrás desarchivarlo después.`,
        confirm: 'Archivar',
      },
      unarchive: {
        title: 'Desarchivar proveedor',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (supplierName) => `Proveedor: ${supplierName}. ¿Deseas desarchivarlo? Volverá a mostrarse como activo.`,
        confirm: 'Desarchivar',
      },
      delete: {
        title: 'Eliminar proveedor',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (supplierName) => `Proveedor: ${supplierName}. ¿Estás seguro de que deseas eliminarlo? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
    },
    mergeModal: {
      title: 'Fusionar proveedores',
      subtitle: 'Unifica información y datos relacionados en un solo proveedor.',
      closeAriaLabel: 'Cerrar modal de fusionar proveedores',
      primarySupplierLabel: 'Proveedor principal',
      mergeWithLabel: 'Fusionar con',
      mergeWithPlaceholder: 'Selecciona proveedor',
      mergeSupplierFallback: 'Proveedor a fusionar',
      noOptions: 'Sin opciones disponibles',
      infoSectionTitle: 'Información',
      billingSectionTitle: 'Datos de facturación',
      contactsSectionTitle: 'Personas de contacto',
      relatedSectionTitle: 'Datos relacionados',
      billingWarning: 'Se unificarán los datos de facturación seleccionados. Si un dato ya fue utilizado en gastos o comisiones no puede excluirse.',
      irreversibleWarning: 'La fusión conservará este proveedor como principal y moverá la información seleccionada del proveedor a fusionar. Revisa los campos, contactos y datos de facturación antes de confirmar.',
      confirmLabel: 'Para confirmar escribe "fusionar"',
      confirmPlaceholder: 'fusionar',
      emptyValue: 'vacio',
      tableHeaders: {
        field: 'Campo',
      },
      summaryLabels: {
        expenses: 'Gastos',
        commissions: 'Comisiones',
        payments: 'Pagos',
      },
      actions: {
        cancel: 'Cancelar',
        submit: 'Fusionar',
        submitting: 'Procesando...',
      },
    },
    expense: {
      toast: {
        saveError: 'No fue posible guardar el gasto.',
        updateSuccess: 'Gasto actualizado correctamente.',
        createSuccess: 'Gasto guardado correctamente.',
      },
    },
    fee: {
      toast: {
        saveError: 'No fue posible guardar la comisión.',
        updateSuccess: 'Comisión actualizada correctamente.',
        createSuccess: 'Comisión guardada correctamente.',
      },
    },
    operation: {
      expenses: {
        table: {
          empty: 'No hay gastos asociados a este proveedor para los filtros seleccionados.',
        },
      },
      fees: {
        table: {
          empty: 'No hay comisiones asociadas a este proveedor para los filtros seleccionados.',
        },
      },
    },
    contributor: {
      toast: {
        deleteSuccess: 'Dato de facturación eliminado correctamente.',
        deleteError: 'No fue posible eliminar el dato de facturación.',
        createSuccess: 'Dato de facturación registrado correctamente.',
        updateSuccess: 'Dato de facturación actualizado correctamente.',
        saveError: 'No fue posible guardar los datos de facturación.',
      },
    },
    toast: {
      updateSuccess: 'Proveedor actualizado correctamente.',
      saveError: 'No fue posible guardar el proveedor.',
      mergeSuccess: 'Proveedor fusionado correctamente.',
      mergeError: 'No fue posible fusionar el proveedor.',
      statusUpdateError: 'No fue posible actualizar el estado del proveedor.',
      deleteSuccess: 'Proveedor eliminado correctamente.',
      deleteError: 'No fue posible eliminar el proveedor.',
    },
    informationTab: {
      common: {
        assign: 'Asignar',
      },
      comments: {
        empty: 'Sin comentarios',
      },
    },
  },
});
